import { AuthOTP } from "../../components/auth";

export default function OTP() {

    return(
        <>
            <AuthOTP/>
        </>
    )

}